import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ContentViewTypes } from '../content-view/content-view.component';
import { DomSanitizer } from '@angular/platform-browser';
import { DocTypeService } from 'src/app/services/doc-type.service';

@Component({
  selector: 'app-main-view',
  templateUrl: './main-view.component.html',
  styleUrl: './main-view.component.scss'
})
export class MainViewComponent implements OnInit, OnChanges {

  @Input({ required: true }) viewData: any = {}
  @Input({ required: true }) courseId: string = '';
  @Input() attendanceView: boolean = false;
  @Input() url: string = '';
  @Output() sessionUpdated: EventEmitter<any[]> = new EventEmitter();
  @Input() viewOnly: boolean = false;
  contentType?: ContentViewTypes
  showView: boolean = false;
  source: any = '';


  constructor(
    private domSenitizer: DomSanitizer,
    private docService: DocTypeService
  ) { }

  getContentType(): ContentViewTypes {
    if (!this.attendanceView) {
      if (this.viewData.sessionType == 'Video') {
        this.source = this.viewData.video_url;
        if (this.docService.isYouTubeUrl(this.source)) {
          this.source = this.docService.getYTVideoId(this.source)
          return ContentViewTypes.YTVideo;
        } else if (this.docService.isVideo(this.source)) {
          return ContentViewTypes.Video
        }
      } else if (this.viewData.sessionType == 'Material') {
        this.source = this.viewData.url
        return ContentViewTypes.Pdf
      } else if (this.viewData.sessionType == 'Material_Text') {
        this.source = this.viewData.text
        return ContentViewTypes.Text
      } else if (this.viewData.sessionType == 'Survey') {
        this.source = this.viewData
        return ContentViewTypes.Survey
      } else if (this.viewData.sessionType == 'Assessment') {
        this.source = this.viewData
        return ContentViewTypes.Assessment
      } else if (this.viewData.sessionType == 'Online' || this.viewData.sessionType == 'Onsite') {
        this.source = this.viewData.history
        return this.docService.getMaterialContentTypes(this.source)
      }
      return ContentViewTypes.Unsupported
    } else {
      this.source = this.url;
      return this.docService.getMaterialContentTypes(this.source)
    }
  }

  sessionUpdate(seenBy: any[]) {
    this.sessionUpdated.emit(seenBy)
  }


  getSecuritySafeUrl() {
    return this.domSenitizer.bypassSecurityTrustResourceUrl(this.source);
  }

  ngOnInit(): void {
    this.contentType = this.getContentType();
    this.showView = true;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['viewData']) {
      this.showView = false;
      this.viewData = changes['viewData'].currentValue
      this.contentType = this.getContentType()
      this.showView = true;
    }
  }

  onVideoError() {
    this.contentType = ContentViewTypes.Unsupported
  }

}